import HSApi from '../../HSApi';
import { NurseOperationResult } from './nurse-operation.result';

export async function getNurseOperationList(page = 0, size = 20, order: null | string): Promise<NurseOperationResult> {
  const res = await HSApi.get<NurseOperationResult>(`/nurse-operations/view?page=${page}&size=${size}&order=${order ?? ''}`);

  return res.data;
}
